export const minimumPage = 1;
export const maximumNumberOfResultsFromIndex = 5000;
